var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("custom-form-dialog", {
        attrs: {
          visible: _vm.customFormDialog.visible,
          "form-config": _vm.customFormDialog.formConfig,
          "page-parts": _vm.customFormDialog.pageParts,
          jobs: _vm.jobs,
          "tenant-instructions": _vm.tenantInstructions
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customFormDialog, "visible", $event)
          },
          callback: _vm.onCustomFormCallback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }